import angular = require("angular");
import TPL = require("templates");
import {SessionService} from "../../services/session";
import {WelcomeController} from "../../modals/welcome";

export class EmailSignupDirective {

  scope = {};
  template;
  link;

  constructor(session: SessionService, $rootScope, $modal, $filter, $log) {
    var translate = $filter('translate');

    this.template = TPL.navigationDirectives.emailSignup;

    this.link = (scope, el, attrs)=> {
        scope.$watch('date', (newvalue,oldvalue) => {
          $log.debug("watch: " + newvalue);
        });

        scope.vm = {
          birthdayFocused: false,
          session: session,
          signupData: {
            highSchoolSelected: "",
            genderSelected: "",
            bbyoMemberSelected: "",
          },
          highSchoolOptions: [
            "2017",
            "2018",
            "2019",
            "2020",
            "2021"
          ],
          genderOptions: [
            "M",
            "F",
            "I do not identity with either"
          ],
          bbyoMemberOptions: [
            "I'm not a member",
            "Big Apple",
            "Central Region West",
            "CSR",
            "Connecticut Valley",
            "Eastern",
            "Evergreen",
            "Gold Coast",
            "GJHRR",
            "Great Midwest",
            "Kentucky Indiana Ohio",
            "Keystone Mountain",
            "Liberty",
            "Lonestar",
            "Manhattan",
            "Mid America",
            "Michigan",
            "Miami",
            "Mountain",
            "New England",
            "North Florida",
            "NRE: DC Council",
            "NRE: Baltimore",
            "NRE: Nova",
            "Nassau Suffolk",
            "North Texas Oklahoma",
            "Ohio Northern",
            "Pacific Western",
            "Rocky Mountain",
            "South Jersey",
            "Southern: Atlanta",
            "Southern: Dixie",
            "Westchester",
            "Wisconsin"
          ],
          errorPasswordTooShort: false,
          errorEmailAlreadyUsed: false,
          errorEmailNotValid: false,

          setBirthdayFocus: (focused) => {
            scope.vm.birthdayFocused = focused;
          },

          getBirthdayPlaceholder: () => {
              if (scope.vm.birthdayFocused) {
                return translate('LOGIN.SIGN_UP_DATE_PLACEHOLDER_EXAMPLE');
              } else {
                return translate('LOGIN.SIGN_UP_DATE_PLACEHOLDER');
              }
          },

          birthdateKeyUp: () => {
            var currentDate : string = scope.signupForm.date.$viewValue;
            if (currentDate != null) {
              if (currentDate.length == 2) {
              $log.debug("birthdateKeyUp " + scope.signupForm.date.$viewValue + "<2>");
                /*if(currentDate.slice(-1) != '/') {
                  scope.signupForm.date.$setViewValue(currentDate + "/");
                  scope.signupForm.date.$render();
                }*/
              } else if (currentDate.length == 5) {
              $log.debug("birthdateKeyUp " + scope.signupForm.date.$viewValue + "<5>");
                /*if(currentDate.slice(-1) != '/') {
                  scope.signupForm.date.$setViewValue(currentDate + "/");
                  scope.signupForm.date.$render();
                }*/
              }
              $log.debug("birthdateKeyUp " + scope.signupForm.date.$viewValue);
            }
          },
          submit: (form) => {
            if (form.$valid) {

              session.signup(scope.vm.signupData).then(() => {
                session.loginWithPassword(scope.vm.signupData.newEmail, scope.vm.signupData.newPassword);

                /*var stopWelcoming = $rootScope.$on("session.login", () => {
                    WelcomeController.open($modal, session, $rootScope);
                    stopWelcoming();
                });*/

              }).catch((error) => {
                $log.debug(error);
                if (error.status == 422) {

                  if (angular.isDefined(error.data.errors.email)) {
                    angular.forEach(error.data.errors.email, (value) => {

                      if (value.indexOf("is invalid") >= 0) {
                        scope.vm.errorEmailNotValid = true;
                      }

                      if (value.indexOf("has already been taken") >= 0) {
                        scope.vm.errorEmailAlreadyUsed = true;
                      }

                    });

                  } else if (angular.isDefined(error.data.errors.password)) {
                    scope.vm.errorPasswordTooShort = true;
                  }
                }


              });
            }
          }
        };
    }
  }

  static factory() {
    var tmp = (a, b, c, d, e) => new EmailSignupDirective(a, b, c, d, e);
    tmp.$inject = ["session", "$rootScope", "$uibModal", "$filter", "$log"];
    return tmp;
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/navigation/emailSignup.ts
 **/